
export const actions = {
  logout({}) {
    if (this.$auth.loggedIn) {
      this.$auth.logout();
    }
  }
}
